/**
 * Message search across all of the user's conversations — the client for
 * `GET /chat/search` (PLAN §12.3.2). Returns the response body unchanged.
 *
 * The search text travels as `q`, the one name the server scrubs from logs and
 * Sentry (chat-search D6); arrays go out as `from[]=…` (axios' default).
 * An axios cancellation becomes an `AbortError`, the palette's silent error.
 */
import { apiClient } from '../utils/apiClient';
import { abortError } from '../palette/types';

function isCancel(err) {
  return !!err && (err.name === 'CanceledError' || err.code === 'ERR_CANCELED' || err.name === 'AbortError');
}

/**
 * @param {{ q?: string, from?: Array, has?: string[], before?: string, after?: string,
 *           channelIds?: Array, limit?: number, cursor?: string }} query
 * @param {{ signal?: AbortSignal }} [opts]
 */
export async function search({ q, from, has, before, after, channelIds, limit, cursor } = {}, { signal } = {}) {
  const params = {};
  if (q != null && q !== '') params.q = q;
  if (from && from.length) params.from = from;
  if (has && has.length) params.has = has;
  if (before) params.before = before;
  if (after) params.after = after;
  if (channelIds && channelIds.length) params.channel_ids = channelIds;
  if (limit != null) params.limit = limit;
  if (cursor) params.cursor = cursor;
  try {
    const res = await apiClient.get('/chat/search', { params, signal });
    if (signal?.aborted) throw abortError();
    return res.data;
  } catch (err) {
    if (isCancel(err) || signal?.aborted) throw abortError();
    throw err;
  }
}

const chatSearchAllService = { search };
export default chatSearchAllService;
